import request from '@/utils/request'

export async function getRole(data) {
  return request({
    url: '/role/all',
    method: 'post',
    data,
  })
}
export async function createRole(data) {
  return request({
    url: '/role/save',
    method: 'post',
    data,
  })
}
export async function updateRole(data) {
  return request({
    url: '/role/update',
    method: 'post',
    data,
  })
}
export async function deleteRole(data) {
  return request({
    url: '/role/delete',
    method: 'post',
    data,
  })
}

export async function roleBindPerm(data) {
  return request({
    url: '/role/permission/bind',
    method: 'post',
    data,
  })
}
export async function roleBindUsers(data) {
  return request({
    url: '/role/user/bind',
    method: 'post',
    data,
  })
}
export async function getRoleUser(data) {
  return request({
    url: '/user/findByRoleId',
    method: 'post',
    data,
  })
}
